import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex/row';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { useForecastingData } from './hooks/use-forecasting-data';
import messages from './messages';
import style from './styles.module.less';
import { useExportCSV } from './utils/csv-export/use-export-csv';

/**
 * ForecastingDrawerFooter component that displays the footer of the forecasting drawer
 * @param {object} props - Component props
 * @param {() => void} props.onCreatePurchaseOrderClick - Callback function when create purchase order button is clicked
 * @returns {React.ReactElement} The rendered ForecastingDrawerFooter component
 */
export const ForecastingDrawerFooter = ({ onCreatePurchaseOrderClick }) => {
  const { isLoading, forecastingData, rawEntities } = useForecastingData();
  const exportCSV = useExportCSV();

  const handleExportClick = useCallback(() => {
    if (exportCSV) {
      exportCSV(forecastingData, rawEntities);
    }
  }, [forecastingData, rawEntities, exportCSV]);

  return (
    // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role
    <FlexRow className={style['drawer-footer']} role='region'>
      <Button disabled={isLoading} onClick={handleExportClick} theme={THEME_CONSTANTS.secondary}>
        <FormattedMessage {...messages.exportToCsvButton} />
      </Button>

      <Button disabled={isLoading} onClick={onCreatePurchaseOrderClick} theme={THEME_CONSTANTS.primary}>
        <FormattedMessage {...messages.createPurchaseOrderButton} />
      </Button>
    </FlexRow>
  );
};
